module.exports = __webpack_public_path__ + "img/BKSH1.06387769.jpg";